import { ITranslationEntry } from '../lang';

export const UR: ITranslationEntry = {
  translations: {
    notifications: 'اطلاع',
    markAllAsRead: 'سب کو پڑھا ہوا شمار کریں',
    poweredBy: 'طاقت کے ذریعے',
    settings: 'ترتیبات',
  },
  lang: 'ur',
};
